import React, { useEffect, useMemo, useState } from 'react';
import {
  MobileGameHolder,
  MobileGameStructure,
  MobileGameWr,
} from '@pascal/pascal-core/table-line/table-components';
import {
  DefaultQueryParams,
  GameControllers,
  iframeService,
  SidebarHolder,
  parseQuery,
  RightSideHolder,
  TableFooter,
  useTranslation,
  useUserInfoStore,
  MobileStructureMiddle,
  parseNumberByPrecision,
  OverlayFooter,
  tableBetHistoryStore,
  useSoundWatcher,
} from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { observer } from 'mobx-react-lite';
import { TableMobileHeader } from '@pascal/pascal-core/table-line/table-containers/mobileHeader';
import { useLocation, useNavigate } from 'react-router-dom';
// import NoSleep from 'nosleep.js';
import { GAME_CONTROLLER_TYPES } from '@pascal/pascal-core/shared/core/enums/gameControllerTypes';
import {
  applicationStore,
  betStore,
  gameConfigStore,
  userCountStore,
} from '@pascal/pascal-core/shared/core/store';
import turboGameLogo from '../assets/images/baccarat/shadow-logo.png';
import gameLogo from '../assets/images/baccarat/bacarat-logo.png';
import { HelpPopup } from '../components/helpPopup';
import { BetHistoryWr } from './betHistory';
import { MobileGameMain } from '../game';
import LimitAndPayouts from './payoutsAndResultsContainer/limitsAndPayouts';
import { doBetStore } from '../store/doBetStore';
import { winningAmountStore } from '../store/winningAmountStore';
import MobileResultContainer from './mobileResultContainer';
import { SettingsContainer } from './settingsContainer';
import AdditionalResultWr from './payoutsAndResultsContainer/additionResultWr';
import { TURBO_GAME_ID } from '../enums/constants';
import { gameService } from '../services';

const gameControllerComponents = {
  [GameControllerTypes.Help]: <HelpPopup />,
  [GameControllerTypes.History]: <BetHistoryWr />,
  [GameControllerTypes.Settings]: <SettingsContainer />,
  [GameControllerTypes.Results]: <MobileResultContainer />,
  [GAME_CONTROLLER_TYPES.PAYOUTS_AND_LIMITS]: <LimitAndPayouts />,
};
// const noSleep = new NoSleep();
const secondNumber = 1;

export const MobileGame = observer(({ isReplay }) => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { [DefaultQueryParams.UserId]: userId } = parseQuery(search);
  const [gameControllerType, setGameControllerType] = useState('');
  const { selectedHistoryRow, setSelectedHistoryRow } = tableBetHistoryStore;
  const { usersCount } = userCountStore;
  const { currencyCode } = useUserInfoStore();
  const { betsTotalAmount } = doBetStore;
  const { lastWinAmount } = winningAmountStore;
  const { isTestPlatform } = applicationStore;
  const { isSkipLobby } = gameConfigStore;
  const { repliedBetData } = betStore;
  // const { roomName } = useLobbyStore();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  useSoundWatcher();

  useEffect(() => {
    if (isReplay && repliedBetData) {
      gameService.handleReplay(repliedBetData);
    }
  }, [isReplay, repliedBetData]);

  useEffect(() => {
    if (isTurbo) {
      document.querySelector('.pgc-center-m-header').classList.add('turbo');
    }
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   document.addEventListener('touchstart', enableNoSleep, false);
  //   return () => {
  //     document.removeEventListener('touchstart', enableNoSleep, false);
  //   };
  // }, [enableNoSleep]);

  const GameControllerComponent = useMemo(() => {
    const component = gameControllerComponents[gameControllerType];
    if (component) {
      return component;
    }
    return null;
  }, [gameControllerType]);

  const navigationItems = useMemo(() => {
    const items = [
      {
        icon: 'icon-lobby',
        name: t('LOBBY'),
        onClick: () => {
          navigate(`/${search}`);
        },
      },
      {
        icon: 'icon-limits',
        name: t('LIMITS_AND_PAYOUTS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.PAYOUTS_AND_LIMITS),
        isPayTable: true,
      },
      {
        icon: 'icon-history1',
        name: t('HISTORY'),
        isDisabled: !userId,
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY),
      },
      {
        icon: 'icon-settings',
        name: t('SETTINGS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.SETTINGS),
      },
      {
        icon: 'icon-help',
        name: t('RULES'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HELP),
      },
    ];
    if (isTurbo || isSkipLobby) {
      items.splice(0, 1);
      return items;
    }
    if (isTestPlatform) {
      items.splice(2, 1);
      return items;
    }
    return items;
  }, [isTestPlatform, isTurbo, navigate, search, t, userId, isSkipLobby]);

  useEffect(() => {
    if (!isTurbo && !isReplay) {
      const el = document.createElement('span');
      const parent = document.querySelector('.m-user-count-holder');
      el.classList.add('m-user-count-txt');
      el.innerText = usersCount || '';
      parent.prepend(el);
      if (!usersCount) {
        parent.innerHTML = '';
      }
    }
  }, [usersCount, isTurbo, isReplay]);

  return (
    <MobileGameWr>
      <MobileGameStructure
        hasGameTypeLoading={isSkipLobby}
        hasLobby={isSkipLobby}
        lobbyLogoImageSrc={gameLogo}
      >
        {!isReplay && (
          <TableMobileHeader
            logoSrc={isTurbo ? turboGameLogo : gameLogo}
            isShowGameTypes={!isTurbo}
          />
        )}
        <MobileStructureMiddle haveNotification translationValues={{}}>
          <MobileGameHolder>
            <MobileGameMain isReplay={isReplay} />
          </MobileGameHolder>
          {!isReplay && (
            <>
              <SidebarHolder setGameControllerType={setGameControllerType} hasSideIcon>
                <GameControllers
                  currencyCode={currencyCode}
                  controllerType={gameControllerType}
                  setGameControllerType={() => setGameControllerType(null)}
                  selectedHistoryRow={selectedHistoryRow}
                  setSelectedHistoryRow={setSelectedHistoryRow}
                  gameControllerComponent={GameControllerComponent}
                  hasScrollToBottom={gameControllerType === GAME_CONTROLLER_TYPES.RESULTS}
                  additionalContent={
                    gameControllerType === GAME_CONTROLLER_TYPES.RESULTS ? (
                      <OverlayFooter title={t('LAST_CARDS')}>
                        <AdditionalResultWr />
                      </OverlayFooter>
                    ) : null
                  }
                />
              </SidebarHolder>
              <RightSideHolder navigationItems={navigationItems} hasLobby={!isTurbo} />
            </>
          )}
        </MobileStructureMiddle>
        {!isReplay && (
          <TableFooter
            lastWin={lastWinAmount}
            totalBet={parseNumberByPrecision(betsTotalAmount, secondNumber)}
            centerBlock={
              isTurbo ? null : (
                <>
                  <div className='user-icon-b'>
                    <i className='icon-users' />
                  </div>
                  <div className='m-user-count-holder' />
                </>
              )
            }
          />
        )}
      </MobileGameStructure>
    </MobileGameWr>
  );
});
